<template>
  <div>
    <h4>COMENTARIOS ACERCA DEL PACIENTE</h4>
    <app-comments :url="`dental_client_${client_id}`"></app-comments>
  </div>
</template>
<script>

export default {
  components: {
    //
  },

  // directives
  // filters

  props: {
    client_id: {}
  },

  data: () => ({
    //
  }),

  computed: {
    //
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    //
  }
};
</script>

<style></style>
